import { WSForm } from "@wingspanhq/fe-component-library";
import React from "react";
import { IFormSchemaField } from "../../types";

// Renders nothing — exists purely so the Controller keeps the value registered.
const HiddenValue: React.FC = () => null;

/**
 * `ui.component === "Hidden"` fields (worksheet intermediate lines). Like the
 * auto-calculated box, the field is rendered THROUGH WSForm.Field so it stays
 * RHF-registered — its (usually server-computed) value is seeded into
 * defaultValues, refreshed via setValue on re-evaluation, and included in the
 * submit payload. RHF v6 defaults `shouldUnregister: true`, so an unregistered
 * field would be dropped from the payload. The user sees nothing.
 */
export const DynamicFieldHidden: React.FC<{
  field: IFormSchemaField;
  name?: string;
}> = ({ field, name }) => (
  <WSForm.Field name={name ?? field.key} component={HiddenValue} />
);
